import React,{useState} from 'react'

import * as Survey from "survey-react";
import "survey-react/survey.css";
import './css/style.css';

import CommentComp from "../common/CommentComp";
import StatusComp from "../../common/StatusComp";

const DocumentDetailComp = (props)=>{

    console.log(props.editorItem);

    const[statusMsg,setStatusMsg] = useState({style:"",msg:""});

    const survey = new Survey.Model(props.editorItem.template.templateStr);
    survey.data = props.editorItem.formData;
    survey.mode = 'display';


    return (
        <div className="panel">
            <div className="panel-header">
                <div className="push-left flex">
                    <div className="mr-4">Document detail</div><div className="ml-4 mr-4">Document Status : <StatusComp status={props.editorItem.status}>{props.editorItem.statusLabel}</StatusComp></div>
                    <div className="ml-4 flex">
                        {props.editorItem.createdTimeStampUserTz && <div>Created : {props.editorItem.createdTimeStampUserTz}</div>}
                        {props.editorItem.lastAction !== "Pending" && <div className="ml-4">{props.editorItem.lastAction} : {props.editorItem.updatedTimeStampUserTz}</div>}
                    </div>
                </div>
                <div>
                    <div className="btn-group">
                        {props.editorItem.status !== 'Approved' && 
                            <button type="button" className="btn btn-primary" onClick={p=>props.handleUpdate(props.editorItem)}>Update</button>
                        }
                        <button type="button" className="btn btn-primary" onClick={props.handleClose}>Close</button>
                    </div>
                </div>
            </div>
            <div className="panel-body">
                <Survey.Survey model={survey}/>
                <CommentComp data = {props.editorItem.comments}/>
            </div>
            <div className="panel-footer">
                <div className="btn-group">
                    {props.editorItem.status !== 'Approved' && 
                        <button type="button" className="btn btn-primary" onClick={p=>props.handleUpdate(props.editorItem)}>Update</button>
                    }
                    <button type="button" className="btn btn-primary" onClick={props.handleClose}>Close</button>
                </div>
            </div>
        </div>
    )
}

export default DocumentDetailComp
